// WHY A PLACING RULE COULD NOT PLACE — said by a module that has no language, read by somebody
// who has one. The rules (fromHole, fromJoint, fromSet) throw the KEY of what went wrong and the
// names it is about; the page that catches it says it in the language it is in. They threw the
// English sentence, and a page in French showed it as it was thrown.
export class RuleError extends Error {
  vars: Record<string, string | number>;

  constructor(key: string, vars: Record<string, string | number> = {}) {
    super(key);
    this.vars = vars;
  }
}

const fill = (said: string, vars: Record<string, string | number>) =>
  Object.entries(vars).reduce((out, [name, value]) => out.replace(`{${name}}`, String(value)), said);

// The sentence, in the reader's language. Anything else that was thrown is said as it came.
export const sayRuleError = (e: unknown, tr: (key: string) => string): string => (
  e instanceof RuleError ? fill(tr(e.message), e.vars) : e instanceof Error ? e.message : String(e));

// A RULE THAT IS ABOUT THIS SUB-STEP AND CANNOT PLACE IT, and why: what the page says instead of a
// movement, since no model is asked to guess one. Before anything is loaded, unlike a RuleError,
// which is thrown on the press. A rule that is not about the sub-step at all (a joint rule on a
// screw going into its hole) answers null instead, and says nothing.
export type Declined = { declined: string; vars: Record<string, string | number> };
export const declined = (key: string, vars: Record<string, string | number> = {}): Declined => ({ declined: key, vars });
export const isDeclined = (x: unknown): x is Declined => !!x && typeof x === 'object' && 'declined' in x;
export const sayDeclined = (d: Declined, tr: (key: string) => string): string => fill(tr(d.declined), d.vars);
